var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79.414,
    viewBox: "0 0 79 79.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1e5288;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-359 -5339.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(360 5340.096)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    className: "cls-1",
    width: 77,
    height: 77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    className: "cls-1",
    d: "M1336.854,956.239,1304.6,988.923l-32.256-32.684,31.176-31.857Z",
    transform: "translate(-1266.086 -917.262)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1190",
    "data-name": "Line 1190",
    className: "cls-1",
    x1: 20.587,
    y1: 20.965,
    transform: "translate(54.5 55.404)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1191",
    "data-name": "Line 1191",
    className: "cls-1",
    y1: 21.595,
    x2: 21.192,
    transform: "translate(1.308 55.404)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1192",
    "data-name": "Line 1192",
    className: "cls-1",
    x1: 21.395,
    y2: 21.693,
    transform: "translate(54.323 1.547)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1193",
    "data-name": "Line 1193",
    className: "cls-1",
    x2: 20.325,
    y2: 20.608,
    transform: "translate(1.307 1.547)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1194",
    "data-name": "Line 1194",
    className: "cls-1",
    x2: 8.509,
    y2: 8.627,
    transform: "translate(61.909 47.856)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1195",
    "data-name": "Line 1195",
    className: "cls-1",
    x1: 8.508,
    y2: 8.627,
    transform: "translate(6.259 47.506)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1196",
    "data-name": "Line 1196",
    className: "cls-1",
    y1: 9.668,
    x2: 9.535,
    transform: "translate(61.909 20.93)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1197",
    "data-name": "Line 1197",
    className: "cls-1",
    x1: 8.177,
    y1: 8.291,
    transform: "translate(6.589 22.071)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape-1.045b63b11684760c82fc066365468c79.svg";
export { ForwardRef as ReactComponent };